import { createFileRoute } from "@tanstack/react-router";

import logo1 from "../assets/logo-alt1.png";
import logo2 from "../assets/logo-alt2.png";
import logo3 from "../assets/logo-alt3.png";
import logo4 from "../assets/logo-alt4.png";
import logo5 from "../assets/logo-alt5.png";

const logos = [
  {
    src: logo1,
    label: "Alternatief 1 — Minimalistisch Geometrisch",
    desc: "Strakke 'IT'-vormen in een modern blauw gradient",
  },
  {
    src: logo2,
    label: "Alternatief 2 — Netwerk/Connectie",
    desc: "Verbonden nodes en lijnen voor een digitaal gevoel",
  },
  {
    src: logo3,
    label: "Alternatief 3 — Typografisch Bold",
    desc: "Krachtige typografie met een subtiel tech-accent",
  },
  {
    src: logo4,
    label: "Alternatief 4 — Shield & Security",
    desc: "Bescherming en cybersecurity als kernboodschap",
  },
  {
    src: logo5,
    label: "Alternatief 5 — Hexagon Tech",
    desc: "Futuristische honingraatstructuur met 'IT' geïntegreerd",
  },
];

export const Route = createFileRoute("/logo-preview")({
  head: () => ({
    meta: [
      { title: "Logo Voorstellen — IT Solutions" },
      { name: "description", content: "5 alternatieve logo-ontwerpen voor IT Solutions" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: LogoPreview,
});

function LogoPreview() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b border-border bg-background/80 backdrop-blur sticky top-0 z-50">
        <div className="mx-auto max-w-6xl px-4 py-4 flex items-center justify-between">
          <h1 className="text-lg font-semibold tracking-tight">IT Solutions — Logo Voorstellen</h1>
          <a
            href="/"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            ← Terug naar website
          </a>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-4 py-12">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold tracking-tight mb-3">5 Alternatieve Logo's</h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Hieronder vind je vijf verschillende richtingen. Laat me weten welke je aanspreekt — dan
            verfijnen we die verder!
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2">
          {logos.map((logo, i) => (
            <div
              key={i}
              className="rounded border border-border bg-card p-6 flex flex-col items-center text-center hover:border-primary/50 transition-colors"
            >
              <div className="w-full h-48 flex items-center justify-center bg-white rounded-lg mb-4 overflow-hidden">
                <img
                  src={logo.src}
                  alt={logo.label}
                  className="max-h-full max-w-full object-contain"
                />
              </div>
              <h3 className="font-semibold text-lg mb-1">{logo.label}</h3>
              <p className="text-sm text-muted-foreground">{logo.desc}</p>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
